import {Component, OnInit} from '@angular/core';
import {UserService, UserType} from '@common/messe-ui-toolkit';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouteBuilder} from '@util/route-builder';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [MarkantElementsModule],
})
export class LoginComponent implements OnInit {
  constructor(
    private readonly voilaUserService: UserService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.voilaUserService
      .loggedInUser()
      .pipe(take(1))
      .subscribe((currentUser) => {
        // TODO: route to error page if user not found in db! see former LoginRouteGuard...
        switch (currentUser.userGroupKey) {
          case UserType.MA:
            this.navigateByUrl(RouteBuilder.app().maDashboard().build());
            break;
          case UserType.HP:
            this.navigateByUrl(RouteBuilder.app().hpDashboard().build());
            break;
          case UserType.IP:
            this.navigateByUrl(RouteBuilder.app().startupDashboard().build());
            break;
          case UserType.UNKNOWN:
            this.navigateByUrl(RouteBuilder.build());
            break;
        }
      });
  }

  private navigateByUrl(url: string) {
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigateByUrl(url);
  }
}
